module.exports = __webpack_public_path__ + "assets/img/567c7924d733a31703573f2bf70e10bb.png";